export const ACC_UNIF_REQ_STATUS = {
    "Pending": "Pendiente",
    "In Process": "En proceso",
    "Unified": "Unificado",
};